import { defineComponent as _defineComponent } from 'vue'
import {config, userConfig} from '@/store';
import languages from '@/store/language';
import theme from '@/store/theme';
import {computed, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {set_theme, themes} from '@/style/theme';
import {Search} from '@element-plus/icons-vue';
import {useRoute} from 'vue-router';
import router from '@/router';
import layoutDic from '@/store/top-layout';
import routeType from '@/type/route';

export default /*#__PURE__*/_defineComponent({
  __name: 'top-nav',
  setup(__props, { expose: __expose }) {
  __expose();

const {locale} = useI18n();
const route = useRoute();

const searchText = ref('');
const searchType = ref('manga');

// 排序方式
const sortOrder = ['id', 'idDesc', 'name', 'nameDesc', 'time', 'timeDesc'];

// 视图类型
const viewClass = computed(() => {
	const viewType = config.viewType;
	switch (viewType) {
		case 'block':
			return 'icon-gonggeshitu';
		case 'list':
			return 'icon-liebiaoshitu';
		default:
			return 'icon-gonggeshitu';
	}
});

const screenType = computed(() => {
	const screenType = config.screenType;
	switch (screenType) {
		case 'large':
			return true;
		case 'middle':
			return false;
		case 'small':
			return false;
		default:
			return true;
	}
});

const layoutLimit = computed(() => (key: string) => {
	const screen = config.screenType;
	const view = route.meta.view as routeType;
	let layoutArr: string[];

	if (view) {
		layoutArr = layoutDic[view][screen];
	} else {
		layoutArr = layoutDic.default[screen];
	}

	return layoutArr.includes(key);
});

/**
 * 去往搜索界面
 */
function go_search() {
	if (!searchText.value) {
		return false;
	}

	router.push({
		name: 'search',
		params: {
			searchText: searchText.value,
			searchType: searchType.value,
		},
	});
}

function search_noval() {
	router.push({
		name: 'search',
	});
}

function handleSelect(key: string) {
	switch (key) {
		case 'switch_sidebar':
			config.sidebarCollapse = !config.sidebarCollapse;
			break;
		default:
			break;
	}
}

function sort_order_change(val: string) {}

function language_change(val: string) {
	locale.value = val;
	localStorage.setItem('language', val);
}

function theme_change(val: string) {
	set_theme(val);
	localStorage.setItem('theme', val);
}

function theme_color(theme: string) {
	// @ts-ignore
	const color = themes[theme]['s-back'];
	return {
		backgroundColor: color,
	};
}

function switch_view_type() {
	if (config.viewType === 'block') {
		config.viewType = 'list';
	} else if (config.viewType === 'list') {
		config.viewType = 'block';
	}
}

const __returned__ = { locale, route, searchText, searchType, sortOrder, viewClass, screenType, layoutLimit, go_search, search_noval, handleSelect, sort_order_change, language_change, theme_change, theme_color, switch_view_type, get config() { return config }, get userConfig() { return userConfig }, get languages() { return languages }, get theme() { return theme }, get Search() { return Search }, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})